<!-- @format -->

<ng-container *transloco="let t">
  <div class="modal-header">
    <button type="button" class="modal-close" (click)="close()" [attr.aria-label]="t('ARIA_LABEL.CLOSE')">
      <sis-icon icon="ring-close"></sis-icon>
    </button>
    <h2>{{ t("STUDY_RIGHT_EXTENSION_REQUIREMENTS_MODAL.TITLE") }}</h2>
  </div>
  <div class="modal-body">
    @if (isNoPrimaryPlanInfoVisible && educationId | education | async; as education) {
      <div>
        <p>
          <transloco
            key="STUDY_RIGHT_EXTENSION_REQUIREMENTS_MODAL.PRIMARY_PLAN_NEEDED"
            [params]="{ educationname: education.name | localizedString }" />
        </p>
      </div>
    }
    @if (isNotPlannedInfoVisible) {
      <div>
        <p>
          <transloco key="STUDY_RIGHT_EXTENSION_REQUIREMENTS_MODAL.PLAN_HAS_TO_BE_IN_PLANNED_STATE" />
        </p>
        <p>
          <transloco key="STUDY_RIGHT_EXTENSION_REQUIREMENTS_MODAL.TIMING_INSTRUCTIONS" />
        </p>
      </div>
    }
    @if (isUntimedStudiesInfoVisible) {
      <div>
        @if (untimedCourseUnits) {
          <p>
            <transloco key="STUDY_RIGHT_EXTENSION_REQUIREMENTS_MODAL.UNTIMED_COURSE_UNITS" />
          </p>
        }
        @if (untimedCustomStudyDrafts) {
          <p>
            <transloco key="STUDY_RIGHT_EXTENSION_REQUIREMENTS_MODAL.UNTIMED_CUSTOM_STUDY_DRAFTS" />
          </p>
        }
      </div>
    }
    @if (isStudiesTimedInThePastInfoVisible) {
      <div>
        @if (courseUnitsTimedInThePast) {
          <p>
            <transloco key="STUDY_RIGHT_EXTENSION_REQUIREMENTS_MODAL.COURSE_UNITS_WITH_TIMING_IN_THE_PAST" />
          </p>
        }
        @if (customStudyDraftsTimedInThePast) {
          <p>
            <transloco key="STUDY_RIGHT_EXTENSION_REQUIREMENTS_MODAL.CUSTOM_STUDY_DRAFTS_WITH_TIMING_IN_THE_PAST" />
          </p>
        }
      </div>
    }
  </div>

  <div class="modal-footer">
    @if (isCreatePlanButtonVisible) {
      <button type="button" (click)="createPlan()" class="btn btn-primary btn-hollow btn-sm">
        <span>
          {{ t("STUDY_RIGHT_EXTENSION_REQUIREMENTS_MODAL.CREATE_PLAN") }}
        </span>
      </button>
    }
    @if (isProceedToPlanButtonVisible) {
      <button type="button" (click)="proceedToPlan()" class="btn btn-primary btn-hollow btn-sm">
        <span>
          {{ t("STUDY_RIGHT_EXTENSION_REQUIREMENTS_MODAL.PROCEED_TO_PLAN") }}
        </span>
      </button>
    }
    @if (isProceedToTimingButtonVisible) {
      <button type="button" (click)="proceedToTiming()" class="btn btn-primary btn-hollow btn-sm">
        <span>
          {{ t("STUDY_RIGHT_EXTENSION_REQUIREMENTS_MODAL.PROCEED_TO_TIMING") }}
        </span>
      </button>
    }
  </div>
</ng-container>
